import { CollapsibleSection } from '../sections/collapsible-section';
import { TaskDescriptionEditor } from './TaskDescriptionEditor';

const NOOP = () => Promise.resolve();

interface TaskDescriptionSectionProps {
  content: string;
  orgId: number;
  canEdit: boolean;
  onSave: (content: string) => Promise<void>;
}

/** The "Description" section: same CollapsibleSection chrome as every other slideout section. */
export function TaskDescriptionSection({
  content,
  orgId,
  canEdit,
  onSave,
}: TaskDescriptionSectionProps) {
  return (
    <CollapsibleSection title='Description'>
      <div className='pt-1'>
        <TaskDescriptionEditor
          content={content}
          orgId={orgId}
          canEdit={canEdit}
          onSave={canEdit ? onSave : NOOP}
        />
      </div>
    </CollapsibleSection>
  );
}
